<template>
  <div class="invitation-container">
    <!-- 标题 -->
    <div class="dialog-title">邀请好友</div>
    
    <div class="invitation-content">
      <p class="invitation-label"><span class="required">*</span>您的邀请码是</p>
      
      <div class="invitation-code-box" @click="copyInvitationCode">
        <span class="invitation-code">{{ invitationCode }}</span>
      </div>
      
      <p class="invitation-tip">分享此码以获取您的专属推荐奖励</p>
    </div>
    
    <!-- 底部按钮 -->
    <div class="button-container">
      <el-button type="primary" class="copy-button" @click="copyInvitationCode">复制邀请码</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    invitationCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.modelValue
    };
  },
  watch: {
    modelValue(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  },
  methods: {
    viewInvitationMechanism() {
      // 处理查看邀请机制的逻辑
      console.log('查看邀请机制');
    },
    copyInvitationCode() {
      // 复制邀请码的逻辑
      if (!this.invitationCode) {
        this.$message.warning('邀请码为空');
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        // 使用现代浏览器的剪贴板 API
        navigator.clipboard.writeText(this.invitationCode)
          .then(() => {
            this.$message.success('邀请码已复制到剪贴板');
          })
          .catch(err => {
            console.error('复制邀请码失败:', err); // 打印错误信息
            this.$message.error('复制邀请码失败，请手动复制');
            this.fallbackCopyText(this.invitationCode);
          });
      } else {
        // 提供手动复制的降级方案
        this.fallbackCopyText(this.invitationCode);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.value = text;
      input.select();
      if (document.execCommand('Copy')) {
        this.$message.success('邀请码已复制到剪贴板');
      } else {
        this.$message.error('复制邀请码失败，请手动复制');
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style scoped>
.invitation-container {
  padding: 8px 32px 32px 32px;
}

.dialog-title {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 24px;
  color: #2e2e2e;
  letter-spacing: 2px;
}

.invitation-content {
  text-align: left;
}

.invitation-label {
  font-size: 18px;
  color: #6b6b6b;
  margin: 0 0 12px 0;
  text-align: center;
}

.required {
  color: #b65a5a;
  font-weight: 700;
  margin-right: 6px;
}

.invitation-code-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fbfbfb;
  border: 2px solid #e3e3e3;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  padding: 16px 20px;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s;
  margin: 0 auto 16px;
}

.invitation-code-box:hover {
  border-color: #4a97ee;
}

.invitation-code {
  font-size: 26px;
  font-weight: 500;
  color: #2f2f2f;
  letter-spacing: 2px;
  word-break: break-all;
}

.invitation-tip {
  font-size: 16px;
  color: #9b9b9b;
  margin: 0 0 24px 0;
  text-align: center;
}

/* 按钮容器 */
.button-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 0 !important;
  position: relative !important;
}

/* 复制按钮 */
.copy-button {
  width: 100%;
  height: auto;
  border-radius: 10px;
  background: #4a97ee;
  color: #fff;
  font-size: 18px;
  border: none;
  padding: 14px 0;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.12);
  margin: 0;
}

.copy-button:hover {
  background: #2f73c7;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .invitation-container {
    padding: 8px 28px 28px 28px;
  }
  
  .dialog-title {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  .invitation-label {
    font-size: 16px;
  }
  
  .invitation-code-box {
    padding: 14px 16px;
  }
  
  .invitation-code {
    font-size: 22px;
  }
  
  .invitation-tip {
    font-size: 14px;
    margin-bottom: 20px;
  }
  
  .button-container {
    margin-top: 0 !important;
  }
  
  .copy-button {
    font-size: 16px;
    padding: 12px 0;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .invitation-container {
    padding: 8px 28px 28px 28px;
  }
  
  .dialog-title {
    font-size: 24px;
    margin-bottom: 22px;
  }
  
  .invitation-label {
    font-size: 17px;
  }
  
  .invitation-code {
    font-size: 24px;
  }
  
  .copy-button {
    font-size: 17px;
    padding: 13px 0;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .invitation-container {
    padding: 6px 20px 20px 20px;
  }
  
  .dialog-title {
    font-size: 20px;
    margin-bottom: 16px;
  }
  
  .invitation-label {
    font-size: 15px;
  }
  
  .invitation-code-box {
    padding: 12px 14px;
  }
  
  .invitation-code {
    font-size: 20px;
  }
  
  .invitation-tip {
    font-size: 13px;
    margin-bottom: 16px;
  }
  
  .button-container {
    margin-top: 0 !important;
  }
  
  .copy-button {
    font-size: 15px;
    padding: 12px 0;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .invitation-container {
    padding: 8px 28px 28px 28px;
  }
  
  .dialog-title {
    font-size: 21px;
    margin-bottom: 16px;
  }
  
  .invitation-code-box {
    padding: 12px 16px;
  }
  
  .invitation-code {
    font-size: 20px;
  }
  
  .copy-button {
    font-size: 15px;
    padding: 11px 0;
  }
}
</style>